import NewGameContainer from './game-new-container';

export default {
    path: '/new',
    component: NewGameContainer,
    routes: []
};




// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/new/index.js